<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">店铺</a></el-breadcrumb-item>
          <el-breadcrumb-item>店铺列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-form-item>
            <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddChainStore" >新增</el-button>
          </el-form-item>         
          <el-form-item >
            <el-input  placeholder="店铺名称" size="small" v-model="queryParam.name" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-input  placeholder="所属商家" size="small" v-model="queryParam.businessName" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-input  placeholder="行业" size="small" v-model="queryParam.industryName" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="Search" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="chainStores" style="width: 100%">
          <el-table-column  prop="Name" :show-overflow-tooltip="true" fixed="left" label="店铺名称"> </el-table-column>
          <el-table-column  prop="Icon" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.Icon"
                placement="right"
                trigger="hover"
              >
                <div>
                  <img
                    :src="scope.row.Icon"
                    width="400"
                  >
                </div>  
                <img
                  slot="reference"
                  :src="scope.row.Icon"
                  width="20"
                  height="20"
                >
              </el-popover> 
              <p v-else>
                --
              </p>
            </template>         
          </el-table-column> 
          <el-table-column  prop="BusinessName"  :show-overflow-tooltip="true"  label="所属商家"> </el-table-column>
          <el-table-column  prop="IndustryName"  width="80px" label="行业"> </el-table-column>
          <el-table-column  prop="PerCapitaConsumeAmount" width="80px" label="人均消费"> </el-table-column>
          <el-table-column  prop="Score"  label="评分" width="80px" > </el-table-column>
          <el-table-column  prop="BrowseCount"  label="浏览人次"  width="80px"  ></el-table-column>
          <el-table-column  prop="RegisterTime"  width="120px" label="注册时间" :formatter="dateFormat"> </el-table-column>
          <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="Edit(scope.row.Id)" type="text" size="small">编辑</el-button>
            <el-button @click.native.prevent="DeleteRow(scope.row.Id)" type="text" size="small">&nbsp; 删除 </el-button>
          </template>
        </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        chainStores:[],
        queryParam: {
          name:'',
          businessName:'',
          industryName:'',
          pageIndex:1,
          pagesize:10,
          sort:' RegisterTime desc',
          totalCount:10,
        }
      }
    },
    computed:{
    },
    mounted(){
      if (this.$route.params.queryParam) {
        this.queryParam = this.$route.params.queryParam
      }
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.queryParam.pageIndex = 1;
        this.GetData();
      },
      AddChainStore:function(){
        this.$router.push({
          name:'chainStoreInfo',
          params:{
            Id:0
          }
        })
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/ChainStore/index',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.chainStores = resp.data.chainStores
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      Edit(id){
        this.$router.push({
          name:'chainStoreInfo',
          params:{
            Id:id,
            queryParam: this.queryParam
          }
        })
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该店铺吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/ChainStore/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
  

</style>